import React from "react";
import { HiOutlineBriefcase } from "react-icons/hi";
import { motion } from "framer-motion";
import ExperienceList from "./ExperienceList";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";

const Experience = () => {
  const data = [
    {
      label: "Work Experience",
      value: "Work Experience",
      icon: HiOutlineBriefcase,
      desc: <ExperienceList />,
    },
  ];
  return (
    <section id="experience" className="min-h-[80vh] -mt-11 pt-40">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Tabs
          value={data[0].value}
          className="w-full flex items-center flex-col py-10"
        >
          <TabsHeader className="md:w-96 w-80 flex items-center mb-5 drop-shadow-xl">
            {data.map(({ label, value, icon }) => (
              <Tab key={value} value={value}>
                <div className="flex items-center gap-2">
                  {React.createElement(icon, { className: "w-5 h-5" })}
                  {label}
                </div>
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody
            // animate={{
            //   initial: { y: 100 },
            //   mount: { y: 0 },
            //   unmount: { y: 100 },
            // }}
            className="flex justify-center"
          >
            {data.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                {desc}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </motion.div>
    </section>
  );
};

export default Experience;
